import { h, Component } from 'preact';
import { connect } from 'unistore/preact';
import style from './style.css';
import common from '../../../common/common';
import { onChange } from '../../../controller/theme_checkout';

class Steps extends Component {
  constructor(props) {
    super(props);
  }

  goBackStep = e => {
    e.preventDefault();
    if (this.props && this.props.isGenerateCodeStepEnabled && this.props.onKeyValueChange) {
      common.log('onClick', 'STEP 1');
      this.props.onKeyValueChange('isGenerateCodeStepEnabled', false);
    }
  };

  render({ isGenerateCodeStepEnabled }) {
    return (
      <div className={`${style['stage-wrap']}`}>
        <div
          className={`${style.steps} ${style[isGenerateCodeStepEnabled ? 'cursor' : 'active']}`}
          onClick={this.goBackStep}
        >
          <p className={`${style['steps-txt']}`}>
            STEP 1
            {isGenerateCodeStepEnabled && (
              <img
                src={`${common.getStaticPath()}/assets/ic-check-cirlce.svg`}
                className={`${style['succ-icon']}`}
                alt=""
              />
            )}
          </p>
          <p className={`${style['steps-subtxt']} ${isGenerateCodeStepEnabled ? style['prev-active'] : ''}`}>
            Checkout page customization
          </p>
        </div>
        <div className={`${style.steps} ${style[isGenerateCodeStepEnabled ? 'active' : '']}`}>
          <p className={`${style['steps-txt']}`}>STEP 2</p>
          <p className={`${style['steps-subtxt']}`}>Code integration</p>
        </div>
        {/* <div className={`${style['steps']}`}>
          <p className={`${style['steps-txt']}`}>STEP 3</p>
          <p className={`${style['steps-subtxt']}`}>Test integration</p>
        </div> */}
      </div>
    );
  }
}

export default connect(
  'isGenerateCodeStepEnabled',
  onChange
)(Steps);



// WEBPACK FOOTER //
// ./checkout/components/steps/index.js